import { AsyncValidatorFn } from '@angular/forms';

export interface ValidationsBuilderModel {
	validation: AsyncValidatorFn;
	messages: string[];
}
